var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.fragment ? 'Fragment' : 'FragmentFallback',{tag:"component"},[(_vm.active)?_vm._t(_vm.variant):_vm._t("a")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }